/**
 * Do not edit directly
 * Generated on Mon, 15 Apr 2024 06:34:30 GMT
 */
const tokens = {
    component: {
        datePicker: {
            header: {
                paddingBottom: {
                    value: "24px",
                    type: "dimension",
                },
                borderBottomWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderBottomColor: {
                    value: "#dadada",
                    type: "color",
                },
                borderBottomStyle: {
                    value: "solid",
                    type: "borderStyle",
                },
                gap: {
                    value: "16px",
                    type: "dimension",
                },
                title: {
                    color: {
                        value: "#282e37",
                        type: "color",
                    },
                    fontSize: {
                        value: "1rem",
                        type: "dimension",
                    },
                    lineHeight: {
                        value: "1.5rem",
                        type: "dimension",
                    },
                    fontWeight: {
                        value: 600,
                        type: "number",
                    },
                    letterSpacing: {
                        value: "0.2px",
                        type: "dimension",
                    },
                },
            },
            footer: {
                paddingTop: {
                    value: "24px",
                    type: "dimension",
                },
                borderTopWidth: {
                    value: "1px",
                    type: "dimension",
                },
                borderTopColor: {
                    value: "#dadada",
                    type: "color",
                },
                borderTopStyle: {
                    value: "solid",
                    type: "borderStyle",
                },
                gap: {
                    value: "16px",
                    type: "dimension",
                },
            },
        },
    },
};
export default tokens;
